import React from 'react';

type AgentFilterChip = {
    label: string;
    value: string;
};

interface CashViewProps {
    filterPanel: React.ReactNode;
    table: React.ReactNode;
    agentAppliedFilters?: AgentFilterChip[];
    batchActionBar?: React.ReactNode;
    embedded?: boolean;
}

const CashView: React.FC<CashViewProps> = ({
    filterPanel,
    table,
    agentAppliedFilters = [],
    batchActionBar = null,
    embedded = false,
}) => (
    <>
        {(filterPanel || agentAppliedFilters.length > 0) && (
        <div className={embedded ? 'mb-3' : 'bg-white rounded-lg mb-3'}>
            {filterPanel}
            {agentAppliedFilters.length > 0 && (
                <div className="px-1 pb-2">
                    <div className="flex flex-wrap items-center gap-2">
                        <span className="text-[11px] font-medium uppercase tracking-[0.08em] text-gray-500">
                            Agent Filter
                        </span>
                        {agentAppliedFilters.map((filter, index) => (
                            <span
                                key={`${filter.label}-${filter.value}-${index}`}
                                className="rounded-full border border-gray-200 bg-gray-50 px-2.5 py-1 text-[11px] text-gray-600"
                            >
                                {filter.label}: {filter.value}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </div>
        )}

        <div className="flex-1 min-h-0 overflow-hidden bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="flex h-full min-h-0 flex-col overflow-hidden">
                {table}
            </div>
        </div>

        {batchActionBar}
    </>
);

export default CashView;
